import { Box, Button, forwardRef, rem, StyleProps } from '@bonusly/design-system';

import { usePrivacy } from './hooks/use-privacy';

type PrivacyButtonProps = StyleProps;

export const PrivacyButton = forwardRef<PrivacyButtonProps, 'button'>((props, ref) => {
	const { selectedOption, buttonEnabled } = usePrivacy();

	return (
		<Button
			aria-label={selectedOption.description}
			borderRadius={rem(22)}
			borderColor="gray.100"
			borderStyle="solid"
			borderWidth="1px"
			colorScheme="secondary"
			h={{ base: rem(36), xs: rem(44) }}
			variant="ghost"
			_hover={{
				backgroundColor: 'gray.25',
				borderColor: 'gray.400',
			}}
			isDisabled={!buttonEnabled}
			ref={ref}
			data-testid="privacy-button"
			{...props}
		>
			{selectedOption.icon}
			<Box
				display={{
					base: 'none',
					md: 'block',
				}}
				ml={1}
			>
				{selectedOption.label}
			</Box>
		</Button>
	);
});
